import { render } from "./TermsAndConditions.vue?vue&type=template&id=61c2f728&scoped=true"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js"

import "./TermsAndConditions.vue?vue&type=style&index=0&id=61c2f728&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c2f728"]])

export default __exports__